import { Form } from 'react-bootstrap';
import FusionCustomInput from 'components/FusionCustomInput/FusionCustomInput';
import { formatDateTimeLocalInput, formatTimeZoneWithOffset } from 'utils/dates/date.utils';
import IpawsFieldFindings, {
  getIpawsFieldFindingDescriptionId,
} from '../IpawsFieldFindings/IpawsFieldFindings';
import { joinDescriptionIds } from '../../utils/ipawsAlertFields.utils';

const IpawsDateTimeField = ({
  controlId,
  fieldPath,
  label,
  value,
  onChange,
  findings = [],
  minimum,
  timeZoneValue = value,
}) => {
  const timeZoneDescriptionId = `${controlId}-zone`;
  const findingDescriptionId = getIpawsFieldFindingDescriptionId(fieldPath, findings);
  const hasFinding = Boolean(findingDescriptionId);

  return (
    <FusionCustomInput controlId={controlId} label={label} fullWidth>
      <Form.Control
        className="alert-creator-control"
        type="datetime-local"
        name={fieldPath}
        value={formatDateTimeLocalInput(value)}
        onChange={onChange}
        {...(minimum ? { min: formatDateTimeLocalInput(minimum) } : {})}
        isInvalid={hasFinding}
        aria-invalid={hasFinding}
        aria-describedby={joinDescriptionIds(timeZoneDescriptionId, findingDescriptionId)}
      />
      <small id={timeZoneDescriptionId} className="d-block mt-1">
        {formatTimeZoneWithOffset(timeZoneValue)}
      </small>
      <IpawsFieldFindings fieldPath={fieldPath} findings={findings} />
    </FusionCustomInput>
  );
};

export default IpawsDateTimeField;
